import { type FC } from "react";
import { ScoutCountTypeLabel } from "@root/clientFrontend/features/scout/components/ScoutCountTypeLabel";
import * as styles from "./styles.css";

/* eslint-disable camelcase */
type ScoutCount = {
  type_name: string;
  start_date: string;
  end_date: string;
  scout_count: number | null;
  premium_scout_count: number | null;
  national_qualifications_scout_count: number | null;
  ai_message_count: number | null;
};

type Props = {
  scout_counts: ScoutCount[];
};

export const SpScoutRemainingCountDetail: FC<Props> = ({ scout_counts }) => {
  return (
    <>
      {scout_counts.map((count, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={`job-${index}`} className={styles.card}>
          <div className={styles.periodLabel}>有効期限</div>
          <div className={styles.cardContent}>
            <div className={styles.periodRow}>
              <span className={styles.period}>
                {count.start_date} ~ {count.end_date}
              </span>
              <span className={styles.typeLabel}>
                <ScoutCountTypeLabel typeName={count.type_name} />
              </span>
            </div>
            <hr className={styles.hr} />

            {/* ジョブスカウト情報 */}
            {count.scout_count !== null && (
              <>
                <p className={styles.line}>
                  スカウト残数： <span className={styles.boldText}>{count.scout_count}</span>通
                </p>
                <p className={styles.subLine}>
                  うちプレミアムスカウト{count.premium_scout_count}通
                </p>
                <p className={styles.subLine}>
                  うち国家資格職種希望者向け{count.national_qualifications_scout_count}通
                </p>
              </>
            )}

            {/* AIメッセージ情報 */}
            {count.ai_message_count !== null && (
              <p className={styles.line}>
                AIメッセージ使用可能回数：{" "}
                <span className={styles.boldText}>{count.ai_message_count}</span>回
              </p>
            )}
          </div>
        </div>
      ))}
    </>
  );
};
